"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Upload = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const react_bootstrap_1 = require("react-bootstrap");
const storage_1 = require("firebase/storage");
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const util_1 = require("./util");
const hooks_1 = require("../hooks");
const components_1 = require("utils/components");
const storage = (0, storage_1.getStorage)(firebase_app_1.default);
const wait = (time) => new Promise((resolve) => setTimeout(resolve, time));
const Upload = (props) => {
    const { value, onChange, rootPath, name, hasError, accept, mode, onFile, disposition, } = props;
    const inputRef = (0, react_1.useRef)(null);
    const toast = (0, hooks_1.useToast)();
    const clear = () => {
        onChange(null);
        onFile === null || onFile === void 0 ? void 0 : onFile(null);
        setProgress(0);
        if (inputRef.current) {
            inputRef.current.value = "";
        }
    };
    const [progress, setProgress] = (0, react_1.useState)(0);
    const [completed, setCompleted] = (0, react_1.useState)(false);
    const displayValue = (0, react_1.useMemo)(() => {
        if (mode !== "filename") {
            return value && typeof value === "object"
                ? JSON.stringify(value || "")
                : value || "";
        }
        else {
            const searchParams = new URLSearchParams(value);
            return searchParams.get("name") || "";
        }
    }, [value]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.ProgressBar, { now: progress, style: { height: 4, opacity: progress > 0 ? 1 : 0 } }),
        react_1.default.createElement(react_bootstrap_1.InputGroup, { className: "mb-3" },
            react_1.default.createElement(Form_1.default.Control, { type: "url", className: (0, classnames_1.default)({
                    "has-error": hasError,
                }), value: displayValue, style: { position: "relative", paddingRight: "39px" }, name: name, onChange: (e) => {
                    if (mode === "filename")
                        return;
                    const str = ((value) => {
                        try {
                            return JSON.parse(value);
                        }
                        catch (_a) {
                            return value;
                        }
                    })(e.target.value);
                    onChange(str);
                }, readOnly: mode === "filename", disabled: mode === "filename" }),
            react_1.default.createElement(components_1.FormClearButton, { onClick: clear, style: { position: "absolute", right: "39px" } }),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", style: { position: "relative" } },
                !completed && progress > 0 ? (react_1.default.createElement("div", null,
                    react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", role: "upload", size: "sm" }))) : (react_1.default.createElement("i", { className: "mdi mdi-cloud-upload-outline" })),
                react_1.default.createElement("input", Object.assign({}, (accept ? { accept } : undefined), { type: "file", style: {
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        right: 0,
                        left: 0,
                        opacity: 0,
                    }, ref: inputRef, onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                        var _a;
                        const target = e.target;
                        const blob = (_a = target.files) === null || _a === void 0 ? void 0 : _a[0];
                        if (blob) {
                            onFile === null || onFile === void 0 ? void 0 : onFile(blob);
                            const path = `${rootPath || ""}/${Date.now()}`;
                            const fileRef = (0, storage_1.ref)(storage, path);
                            const contentType = blob.type;
                            if (accept &&
                                accept[0] !== "." &&
                                !(contentType === null || contentType === void 0 ? void 0 : contentType.startsWith(accept.replaceAll("*", "")))) {
                                yield toast({
                                    message: "ファイルタイプが間違っています",
                                    duration: 10000,
                                });
                                return;
                            }
                            const encodeRFC5987ValueChars = (str) => {
                                return (encodeURIComponent(str)
                                    // 単一引用符 ('), 括弧 (), アスタリスク (*) をRFC 5987に準拠してエンコード
                                    .replace(/['()]/g, (match) => "%" + match.charCodeAt(0).toString(16))
                                    .replace(/\*/g, "%2A")
                                    // RFC 3986ではスペースは"+"に置き換えられますが、RFC 5987では"%20"になります。
                                    .replace(/%20/g, " "));
                            };
                            const task = (0, storage_1.uploadBytesResumable)(fileRef, blob, {
                                contentType,
                                cacheControl: "public, max-age=2592000",
                                contentDisposition: `${disposition || "inliine"}; filename*=UTF-8''${encodeRFC5987ValueChars(blob.name)}`,
                            });
                            task.on("state_changed", (snapshot) => {
                                if (snapshot.state === "running") {
                                    const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                    setProgress(percent);
                                }
                                if (snapshot.state === "error" ||
                                    snapshot.state === "canceled") {
                                    setProgress(0);
                                    target.value = "";
                                }
                            });
                            yield task;
                            console.log("upload", {
                                protocol: "gs",
                                host: firebase_app_1.default.options.storageBucket,
                                path,
                                contentType: blob.type,
                                // size: blob.size,
                            }, (0, util_1.encodeSrc)({
                                protocol: "gs",
                                host: firebase_app_1.default.options.storageBucket,
                                path: `/${path}`,
                                contentType: blob.type,
                                name: blob.name,
                                // size: blob.size,
                            }));
                            onChange((0, util_1.encodeSrc)({
                                protocol: "gs",
                                host: firebase_app_1.default.options.storageBucket,
                                path: `/${path}`,
                                contentType: blob.type,
                                name: blob.name,
                                // size: blob.size,
                            }));
                            yield wait(500);
                            setProgress(0);
                            setCompleted(true);
                            target.value = "";
                        }
                    }) })))),
        react_1.default.createElement(react_bootstrap_1.ToastContainer, { position: "bottom-end", className: "position-fixed m-4" },
            react_1.default.createElement(react_bootstrap_1.Toast, { show: completed, onClose: () => setCompleted(false), autohide: true },
                react_1.default.createElement(react_bootstrap_1.Toast.Header, { className: "justify-content-between" },
                    react_1.default.createElement("p", null, "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u4E2D")),
                react_1.default.createElement(react_bootstrap_1.Toast.Body, null, "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F")))));
};
exports.Upload = Upload;
